import React, { useState } from 'react';
import { Radio } from 'antd';
import { CommonButton } from '../../../../components';
import { commonButtonStyle, COLORS, footerContainerStyle, radioButtonBaseStyle, getRadioButtonStyle } from './constants';
import i18next from 'i18next';

export default function RefundSPPayDeduction({ onSubmit, onBack, onCancel, loading }) {
  const [value, setValue] = useState(null);

  const handleSubmit = () => {
    if (value !== null) {
      onSubmit(value);
    }
  };

  return (
    <div style={{ padding: '20px 24px', width: '100%' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '32px',
        paddingBottom: '24px',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <h5 
          style={{ 
            fontSize: '20px',
            fontWeight: 600,
            color: '#1a1a1a',
            marginBottom: '12px',
            lineHeight: '1.4'
          }}
        >
          {i18next.t('text.report.refundShouldDeductSPPay')}
        </h5>
        <p style={{
          fontSize: '14px',
          color: '#666',
          margin: 0,
          lineHeight: '1.5'
        }}>
          {i18next.t('text.report.refundSPPayDeductionDescription')}
        </p>
      </div>
      
      <Radio.Group
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={{ 
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          marginBottom: '40px',
          justifyContent: 'center'
        }}
      >
        <Radio 
          value={true}
          style={getRadioButtonStyle(value === true)}
        >
          Yes
        </Radio>
        <Radio 
          value={false}
          style={getRadioButtonStyle(value === false)}
        >
          No
        </Radio>
      </Radio.Group>
      <div 
        style={{ 
          marginTop: '40px',
          paddingTop: '24px',
          borderTop: '1px solid #e8e8e8',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '16px'
        }}
      >
        <CommonButton
          type="button"
          className="btn btn-secondary"
          onClick={onBack}
          disabled={loading}
          style={commonButtonStyle}
        >
          Back
        </CommonButton>
        <div 
          style={{ 
            display: 'flex',
            flexDirection: 'row',
            gap: '16px',
            alignItems: 'center'
          }}
        >
          <CommonButton
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={loading}
            style={commonButtonStyle}
          >
            Cancel
          </CommonButton>
          <CommonButton
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
            loading={loading}
            disabled={value === null}
            style={commonButtonStyle}
          >
            Submit
          </CommonButton>
        </div>
      </div>
    </div>
  );
}